import React, { useContext, useEffect, useMemo } from "react";
import { MediaContext, MediaProvider } from "./media-store";
import { MediaItem, listMedia } from "./media-api";
import { Loading } from "../components/Loading";
import { Column, Table } from "../table/Table";
import { formatDatetime, monthName } from "simple-utils/dist/date-utils";
import { SiteHeader } from "../SiteHeader";
import { MediaType } from "./media-type";
import { groupBy } from "simple-utils";
import { AddMediaButton } from "./media-upload";
import { Modal } from "../components/Modal";
import { MediaPreviewModal } from "./media-preview";
import { BackButtonBar } from "../comps/BackButton";


function MediaTable({list}:{list:MediaItem[]}){
    const {dispatch} = useContext(MediaContext);

    const cols = useMemo(()=>{
        return [
            {id: "name", label:"Arquivo", render:(m) => m.name },
            {id: "created", label:"Criação", render:(m) => formatDatetime(m.created) },
            {id: "type", label:"Tipo", render:(m) => <MediaType media={m} /> }
        ] as Column<MediaItem>[]
    }, [])


    function pickRow(row:MediaItem){
        dispatch({type:"setMedia", payload: row})
    }

    return <div className="table-view" style={{maxHeight: "calc(100vh - 312px)", position: "relative", overflow:"auto"}}>
        <Table columns={cols} data={list} onClick={pickRow}  />
    </div>
}

function MediaListGroups({list}:{list:MediaItem[]}){
    const groups = useMemo(function(){
        return groupBy(list, m => monthName(m.created) + " de " + m.created.getFullYear());
    }, [list])

    return <>{Object.entries(groups).map(([k, v]) => {
        return <>
            <h3 className="mt-4">{k}</h3>
            <MediaTable list={v} />
        </>
    })}</> 
}


function MediaList(){
    const {state: {mediaList, media}, dispatch} = useContext(MediaContext);
    
    useEffect(function(){
        (async () =>{
            try {
                const list = await listMedia();
                dispatch({type:"setList", payload: list});
            } catch(e){

            }
        })()
    }, []);

    if(mediaList == null)
        return <Loading  />

    if(mediaList.length == 0)
        return <div className="my-4 text-muted">Nenhum arquivo enviado até agora.</div>

    return <>
        <MediaListGroups list={mediaList} />
        {media != null && <Modal title="Preview" onHide={() => dispatch({type:"setMedia", payload: null})}><MediaPreviewModal media={media} /></Modal>}
    </>
}


export function MediaPage(){
    return <MediaProvider>
        <div className="container my-4">
            <SiteHeader />
            <BackButtonBar>
                <div className="d-md-flex flex-grow-1 justify-content-between align-items-center">
                    <h2><i className="far fa-images me-2"></i> Gerenciar Mídias</h2>
                    <AddMediaButton />
                </div>
            </BackButtonBar>
            <MediaList />
        </div>
    </MediaProvider>
}